import {
    MdArrowDropDownCircle,
    MdBorderAll,
    MdBrush,
    MdChromeReaderMode,
    MdDashboard,
    MdExtension,
    MdGroupWork,
    MdInsertChart,
    MdNotificationsActive,
    MdRadioButtonChecked,
    MdSend,
    MdStar,
    MdTextFields,
    MdViewDay,
    MdViewList,
    MdWeb,
    MdWidgets,
    MdViewCarousel,
    MdPages,
    // MdKeyboardArrowDown,
    // MdAccountCircle,
} from 'react-icons/md';

// import pages
import Login from '../newPages/Login';
import AuthorList from '../newPages/AuthorList';
import AuthorAdd from '../newPages/AuthorAdd';
import AuthorEdit from '../newPages/AuthorEdit';
import BlogList from '../newPages/BlogList';
import BlogAdd from '../newPages/BlogAdd';
import BlogEdit from '../newPages/BlogEdit';
import BlogFaqAdd from '../newPages/BlogFaqAdd';
import BlogFaqEdit from '../newPages/BlogFaqEdit';
import BlogFaqList from '../newPages/BlogFaqList';
import SeoEdit from '../newPages/SeoEdit';
import TFA from '../newPages/TFA';
import Profile from '../newPages/Profile';
import Dashboard from '../newPages/Dashboard';
import ContactList from '../newPages/ContactList';
import FaqAdd from '../newPages/FaqAdd';
import FaqEdit from '../newPages/FaqEdit';
import FaqList from '../newPages/FaqList';
import WorkList from '../newPages/WorkList';
import WorkAdd from '../newPages/WorkAdd';
import WorkEdit from '../newPages/WorkEdit';
import WorkSeoEdit from '../newPages/WorkSeoEdit';
import TestimonialList from '../newPages/TestimonialList';
import TestimonialAdd from '../newPages/TestimonialAdd';
import TestimonialEdit from '../newPages/TestimonialEdit';

const routers = [
    {
        path: "/login",
        name: "Login",
        component: Login,
        isSideMenu: false,
        icon: null,
        menuGroup: null,
        type: 'auth'
    },
    {
        path: "/",
        name: "Dashboard",
        component: Dashboard,
        isSideMenu: true,
        icon: MdDashboard,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/tfa",
        name: "TFA",
        component: TFA,
        isSideMenu: false,
        icon: null,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile,
        isSideMenu: false,
        icon: null,
        menuGroup: null,
        type: 'private'
    },
    // {
    //     path: "/user-list",
    //     name: "User List",
    //     component: UserList,
    //     isSideMenu: true,
    //     icon: MdViewCarousel,
    //     menuGroup: null,
    //     type: 'private'
    // },
    {
        path: "/author-list",
        name: "Author List",
        component: AuthorList,
        isSideMenu: true,
        icon: MdPages,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/author-add",
        name: "Author Add",
        component: AuthorAdd,
        isSideMenu: false,
        icon: MdPages,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/author-edit",
        name: "Author Edit",
        component: AuthorEdit,
        isSideMenu: false,
        icon: MdPages,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/blog-list",
        name: "Blog List",
        component: BlogList,
        isSideMenu: true,
        icon: MdPages,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/blog-add",
        name: "Blog Add",
        component: BlogAdd,
        isSideMenu: false,
        icon: MdPages,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/blog-edit",
        name: "Blog Edit",
        component: BlogEdit,
        isSideMenu: false,
        icon: MdPages,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/blog-faq-add",
        name: "Blog FAQ Add",
        component: BlogFaqAdd,
        isSideMenu: false,
        icon: null,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/blog-faq-edit",
        name: "Blog FAQ Edit",
        component: BlogFaqEdit,
        isSideMenu: false,
        icon: null,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/blog-faq-list/:blogId",
        name: "Blog FAQ List",
        component: BlogFaqList,
        isSideMenu: false,
        icon: null,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/seo-edit/:blogId",
        name: "Seo Edit",
        component: SeoEdit,
        isSideMenu: false,
        icon: null,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/project-seo-edit/:workId",
        name: "Project Seo Edit",
        component: WorkSeoEdit,
        isSideMenu: false,
        icon: null,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/lead-list",
        name: "Lead List",
        component: ContactList,
        isSideMenu: true,
        icon: MdWeb,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/faq-list",
        name: "Faq List",
        component: FaqList,
        isSideMenu: true,
        icon: MdInsertChart,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/faq-add",
        name: "Faq Add",
        component: FaqAdd,
        isSideMenu: false,
        icon: MdWidgets,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/faq-edit",
        name: "Faq Edit",
        component: FaqEdit,
        isSideMenu: false,
        icon: MdWidgets,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/project-list",
        name: "Project List",
        component: WorkList,
        isSideMenu: true,
        icon: MdRadioButtonChecked,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/project-add",
        name: "Project Add",
        component: WorkAdd,
        isSideMenu: false,
        icon: MdWidgets,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/project-edit",
        name: "Project Edit",
        component: WorkEdit,
        isSideMenu: false,
        icon: MdWidgets,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/testimonial-list",
        name: "Testimonial",
        component: TestimonialList,
        isSideMenu: true,
        icon: MdGroupWork,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/testimonial-add",
        name: "Testimonial Add",
        component: TestimonialAdd,
        isSideMenu: false,
        icon: null,
        menuGroup: null,
        type: 'private'
    },
    {
        path: "/testimonial-edit",
        name: "Testimonial Edit",
        component: TestimonialEdit,
        isSideMenu: false,
        icon: null,
        menuGroup: null,
        type: 'private'
    },
    // {
    //     path: "/faq-edit",
    //     name: "Faq Edit",
    //     component: FaqEdit,
    //     isSideMenu: false,
    //     icon: MdWidgets,
    //     menuGroup: null,
    //     type: 'private'
    // },
    // {
    //     path: "/cards",
    //     name: "Cards",
    //     component: CardPage,
    //     isSideMenu: true,
    //     icon: MdWeb,
    //     menuGroup: null,
    //     type: 'private'
    // },
    // {
    //     path: "/charts",
    //     name: "Charts",
    //     component: ChartPage,
    //     isSideMenu: true,
    //     icon: MdInsertChart,
    //     menuGroup: null,
    //     type: 'private'
    // },
    // {
    //     path: "/widgets",
    //     name: "Widgets",
    //     component: WidgetPage,
    //     isSideMenu: true,
    //     icon: MdWidgets,
    //     menuGroup: null,
    //     type: 'private'
    // },
    // {
    //     path: null,
    //     name: "Components",
    //     isSideMenu: true,
    //     icon: MdExtension,
    //     menuGroup: [
    //         {
    //             path: "/buttons",
    //             name: "Buttons",
    //             component: ButtonPage,
    //             isGroupMenu: true,
    //             icon: MdRadioButtonChecked,
    //             type: 'private'
    //         },
    //         {
    //             path: "/button-groups",
    //             name: "Button Groups",
    //             component: ButtonGroupPage,
    //             isGroupMenu: true,
    //             icon: MdGroupWork,
    //             type: 'private'
    //         },
    //         {
    //             path: "/forms",
    //             name: "Forms",
    //             component: FormPage,
    //             isGroupMenu: true,
    //             icon: MdChromeReaderMode,
    //             type: 'private'
    //         },
    //         {
    //             path: "/input-groups",
    //             name: "Input Groups",
    //             component: InputGroupPage,
    //             isGroupMenu: true,
    //             icon: MdViewList,
    //             type: 'private'
    //         },
    //         {
    //             path: "/dropdowns",
    //             name: "Dropdowns",
    //             component: DropdownPage,
    //             isGroupMenu: true,
    //             icon: MdArrowDropDownCircle,
    //             type: 'private'
    //         },
    //         {
    //             path: "/badges",
    //             name: "Badges",
    //             component: BadgePage,
    //             isGroupMenu: true,
    //             icon: MdStar,
    //             type: 'private'
    //         },
    //         {
    //             path: "/alerts",
    //             name: "Alerts",
    //             component: AlertPage,
    //             isGroupMenu: true,
    //             icon: MdNotificationsActive,
    //             type: 'private'
    //         },
    //         {
    //             path: "/progress",
    //             name: "Progress",
    //             component: ProgressPage,
    //             isGroupMenu: true,
    //             icon: MdBrush,
    //             type: 'private'
    //         },
    //         {
    //             path: "/modals",
    //             name: "Modals",
    //             component: ModalPage,
    //             isGroupMenu: true,
    //             icon: MdViewDay,
    //             type: 'private'
    //         }
    //     ]
    // },
    // {
    //     path: null,
    //     name: "Contents",
    //     isSideMenu: true,
    //     icon: MdSend,
    //     menuGroup: [
    //         {
    //             path: "/typography",
    //             name: "Typography",
    //             component: TypographyPage,
    //             isGroupMenu: true,
    //             icon: MdTextFields,
    //             type: 'private'
    //         },
    //         {
    //             path: "/tables",
    //             name: "Tables",
    //             component: TablePage,
    //             isGroupMenu: true,
    //             icon: MdBorderAll,
    //             type: 'private'
    //         }
    //     ]
    // }
];

let returnObj = (item) => {
    return {
        path: item.path,
        name: item.name,
        component: item.component,
        type: item.type
    }
}
const singleRoutes = routers.filter((item) => item.path !== null).map((item) => { return returnObj(item) })
const multiRoutes = routers.filter((item) => item.path === null).map((item) => item.menuGroup).flat().map((item) => returnObj(item))
export const pathRoutes = [...singleRoutes, ...multiRoutes];
export const subAdminRoutes = pathRoutes.filter((el) => el.type === 'private').map((el) => { return { label: el.name, value: el.path } });
export default routers;